/* Pufa sticky Add-to-Cart bar.
   - Shows whenever the on-page buy button is out of view: after scrolling well past it, and - on
     order-wizard products only - already at page top when the CTA renders below the first viewport
     (small phones), so there is always a reachable CTA in the thumb zone.
   - Clicking it never adds to cart. On standard products it smooth-scrolls back to the buy button
     and flashes it, so the shopper completes the product's required configuration first. On wizard
     products it opens the wizard modal directly - the modal IS the configurator, so there is
     nothing to scroll back to.

   The "buy button" is the standard Add to Cart when it's visible, or the order-wizard's CTA
   (.owz-cta) on products that hide the standard button (e.g. Custom Capsules). An OFFSET keeps the
   bar from appearing until the buy button is clearly out of view, so the two never overlap. */
(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var id = bar.getAttribute('data-main-atc');
    var givenAtc = id ? document.getElementById(id) : null;
    var btn = bar.querySelector('[data-sticky-atc-btn]');
    if (!btn) return;
    var OFFSET = parseInt(bar.getAttribute('data-offset'), 10) || 160;

    function isVisible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && el.offsetParent !== null;
    }

    // The buy anchor: the standard ATC when visible, else the order-wizard's visible CTA
    // (cached so we don't re-query it on every scroll).
    var owzCta = null;
    function anchor() {
      if (isVisible(givenAtc)) return givenAtc;
      if (!owzCta) owzCta = document.querySelector('.owz-cta');
      if (isVisible(owzCta)) return owzCta;
      return null;
    }

    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    // Reveal once the buy button's bottom is OFFSET px above the viewport top - or, on wizard
    // products, while the CTA is still fully below the viewport (it can render 2-3 screens down
    // on small phones). If nothing is anchorable yet (e.g. the wizard CTA hasn't rendered), fall
    // back to plain scroll depth.
    function update() {
      var a = anchor();
      if (a) {
        var r = a.getBoundingClientRect();
        show(r.bottom < -OFFSET || (a === owzCta && r.top > window.innerHeight));
      } else show(window.scrollY > window.innerHeight + OFFSET);
    }

    if ('IntersectionObserver' in window && givenAtc) {
      new IntersectionObserver(update, { threshold: 0 }).observe(givenAtc);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    setTimeout(update, 800); // re-check once the wizard CTA is likely revealed
    setTimeout(update, 2200); // late safety net for slow wizard init on weak devices
    update();

    // Click -> go configure, never add. preventDefault is belt-and-suspenders on top of the
    // button's type="button" so it can never submit a form.
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      show(false);
      var a = anchor();
      if (a && a === owzCta) { a.click(); return; } // wizard products: open the modal directly
      a = a || document.querySelector('product-info') || document.body;
      a.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var flash = (a.closest && a.closest('product-form, .product-form')) || a;
      flash.classList.remove('pufa-atc-flash');
      void flash.offsetWidth; // restart the animation on repeat clicks
      flash.classList.add('pufa-atc-flash');
      setTimeout(function () {
        flash.classList.remove('pufa-atc-flash');
      }, 1600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
